export const LOGIN_API = "/login";
export const REGISTER_API = "/register";
export const CHANGE_PASS_API = "/changePass";
export const CONFIRM_OTP_API = "/confirmOTP";
export const DASHBOARD_API = "/dashboard";
export const FORGOT_PASS_API = "/forgotPass";
